import { formatMarkerBuild } from '../pages/playtests/format-build-marker.js';
import { StageBadge } from '../pages/playtests/stage-badge.js';
import type { BuildMarkerSummary } from './playtest-sessions-data.js';

interface Props {
  marker: BuildMarkerSummary | null;
}

// Shared build-identifier display: the build label/version followed by the
// dev-stage badge. Originated inline on the playtest session detail; lifted
// here so feedback streams, form submissions and pattern mentions render
// the build identically. A null marker reads as "Unregistered build", the
// same wording the session table uses for feedback that predates any
// registered build.
export function BuildMarkerLabel({ marker }: Props): JSX.Element {
  if (marker === null) {
    return <span className="text-text">Unregistered build</span>;
  }
  return (
    <span className="flex flex-wrap items-center gap-2">
      <span className="text-text">{formatMarkerBuild(marker)}</span>
      {marker.stage !== null ? <StageBadge stage={marker.stage} /> : null}
    </span>
  );
}
